import posthog from "posthog-js";

let posthogInitialized = false;

function getRuntimeConfig() {
  if (typeof window === "undefined") {
    return null;
  }
  return window.__BALLAH_RUNTIME_CONFIG__ ?? null;
}

export function initPostHog(): boolean {
  const config = getRuntimeConfig();
  if (posthogInitialized || !config?.posthogKey) {
    return false;
  }

  posthog.init(config.posthogKey, {
    api_host: config.posthogHost,
    ui_host: "https://us.posthog.com",
    defaults: "2025-05-24",
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    persistence: "localStorage+cookie",
  });

  posthogInitialized = true;
  return true;
}

export function capturePageview(): void {
  if (!posthogInitialized || typeof window === "undefined") {
    return;
  }

  posthog.capture("$pageview", {
    $current_url: window.location.href,
    pathname: window.location.pathname,
    search: window.location.search,
  });
}

export function captureEvent(
  event: string,
  properties?: Record<string, string | number | boolean | null | undefined>,
): void {
  if (!posthogInitialized) {
    return;
  }

  posthog.capture(event, properties);
}
